import { FC } from 'react';

import { IcMusic16Icon } from '@gem/icons';

import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';
import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

interface IAudioPayloadProps {
  titleClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  message: ChatMessage;
  title: string;
  preventInteraction?: boolean;
  onClick(): void;
}

export const AudioPayload: FC<IAudioPayloadProps> = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      Icon={IcMusic16Icon}
      title={title}
      text={message.payload.fileName}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    />
  );
};
